// extracted by mini-css-extract-plugin
export default {"promotions":"MobileTopUp_promotions__p+kVf","promotionItem":"MobileTopUp_promotionItem__5f5B7"};